/**
 * @file CustomQuery page.
 * @author Max van Loosbroek
 */

import React, { useCallback, useEffect, useState } from 'react'
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded'
import { useSafeAsync } from 'tinybots-react-components/lib/hooks'
import { Org } from '../../organisations/OrganisationAccounts/types'
import { OrganisationsSearch } from './OrganisationsSearch/OrganisationsSearch'
import { QueryResultExport } from './QueryResultExport/QueryResultExport'
import { createTheme } from '@material-ui/core'
import { TbMuiThemeProvider } from '../../../common/react/theme/TbMuiThemeProvider'

export const theme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#333333'
    }
  }
})
export interface CustomQueryProps {
  RelationsService: any
  result: { data: any, queryName: string, errors: any }
}

export const CustomQueryComponent = ({ RelationsService, result }: CustomQueryProps) => {
  const [organisations, setOrganisations] = useState<Org[]>([])
  const safeAsync = useSafeAsync()
  const getrelations = useCallback(
    () =>
      safeAsync(
        RelationsService.getOrganisations().then(() => {
          setOrganisations(RelationsService.organisations)
        })
      ),
    []
  )
  useEffect(() => {
    getrelations()
  }, [])

  return (
        <div className='react-component'>
            <TbMuiThemeProvider theme={theme}>
                <section
                    style={{
                      height: 100,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '20px',
                      gap: '40px'
                    }}
                >
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '20px',
                    gap: '40px'
                  }}>
                <a
                        href='/data-group-overview'
                        style={{
                          color: '#333333',
                          fontSize: 16,
                          fontFamily: 'Inter',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          textDecoration: 'none'
                        }}
                    >
                        <ArrowBackIosRoundedIcon
                            fontSize='inherit'
                            style={{
                              fontSize: 20,
                              color: '#333333',
                              marginRight: 10
                            }}
                        />
                        Data groups
                    </a>
                    <p
                        style={{
                          fontSize: 24,
                          color: '#333333',
                          marginRight: 10,
                          fontFamily: 'Inter-medium'
                        }}
                    >
                        Query creator
                    </p>
                    </div>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '20px',
                      gap: '40px'
                    }}>
                      <OrganisationsSearch organisations={organisations} />
                      <QueryResultExport data={result?.data} queryName={result?.queryName} errors={result?.errors} />
                    </div>
                </section>
            </TbMuiThemeProvider>
        </div>
  )
}

export default (props: CustomQueryProps) => <CustomQueryComponent {...props} />
